<template lang="pug">
div
  settings-payment-checkout
  v-divider.basic500.my-5
  settings-recurring-plan
  v-divider.basic500.my-5
  settings-fees-tips

</template>

<script>
import SettingsPaymentCheckout from '@/components/donation/campaign/SettingsPaymentCheckout.vue'
import SettingsRecurringPlan from '@/components/donation/campaign/SettingsRecurringPlan.vue'
import SettingsFeesTips from '@/components/donation/campaign/SettingsFeesTips.vue'

export default {
  name: 'ManageCampaignSettings',
  components: { SettingsPaymentCheckout, SettingsRecurringPlan, SettingsFeesTips },
}
</script>

<style scoped>

</style>